// extracted by mini-css-extract-plugin
module.exports = {"Logo":"styles-module--Logo---NJ-I"};